module.exports = "<button class=\"btn _matinet_btn filte_width\" (click)=\"searchfn.emit()\">Search</button>"